import { Autocomplete, Button, Divider, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useStyle } from "./style";
import * as yup from "yup";
import { useFormik } from "formik";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { Helmet } from "react-helmet-async";
const WalletTransfer = () => {
  const classes = useStyle();  
  const dispatch = useDispatch()
  const[outletData,setOutletData]=useState([])
  // const [bankData, setBankData] = useState([
  //   { id: 1, name: "Bank" },
  //   { id: 2, name: "Bank B" },
  //   { id: 3, name: "Bank C" },
  // ]);

  const validationSchema = yup.object({
    date: yup.date("Select anyone date").required("Select anyone date"),
    outletId: yup.object().required("Select anyone!"),
    bank: yup.string()
    .notRequired("This field can't be empty!"),
    amount: yup
    .string()
    .matches(/^\S.*$/, "Empty space not allowed!")
    .notRequired("This field can't be empty!"),
    walletBalance:yup
    .string()
    .matches(/^\S.*$/, "Empty space not allowed!")
    .notRequired("This field can't be empty!"),
    transferAmount:yup
    .string()
    .matches(/^\S.*$/, "Empty space not allowed!")
    .required("This field can't be empty!"),
    Description:yup
    .string()
    .matches(/^\S.*$/, "Empty space not allowed!")
    .required("This field can't be empty!"),
  });

  const formik = useFormik({
    initialValues: {
      date: moment(),
      outletId:null,
      bank: "",
      amount:"",
      walletBalance:"",
      transferAmount:"",
      Description:""
    },
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  function handleSubmit() {
    console.log(moment(formik.values.date).format('DD-MM-YYYY'));
    const walletData = {
    date: moment(formik.values.date).format('YYYY-MM-DD'),
    outlet_id: formik.values.outletId.id,
    transfer_from: formik.values.bank,
    transfer_to: `${formik.values.outletId.fullname} - Wallet`,
    transfer_amount: parseInt(formik.values.transferAmount),
    description: formik.values.Description
    }
    console.log(walletData)
    axios.post(`/v1/wallet_trnasfer_master` , walletData)
    .then((res) => {
        console.log(res);
        formik.resetForm();
        dispatch(setSnackbar(true , 'success' , "wallet transfer successfully!"))
    })
    .catch((err) => {
        console.log(err);
        dispatch(setSnackbar(true , 'error' , err.data.errors[0].message))
    })
  }
  const getOutletData = () => {
    axios.get(`/v1/outlet/list/1`)
      .then((res) => {
        setOutletData(res.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch(setSnackbar(true, "error", "err.response.data.response"));
      });
  };
  const handlChange = (e, value) => {
console.log(e , value)
console.log(value.bankname)
formik.setFieldValue('bank' , value.bankname)
formik.setFieldValue("outletId", value);
axios.post(`/v1/closing_expences_master/bank_amount`,{outlet_id : value.id})
.then((res)=>{
    console.log(res) ; 
    formik.setFieldValue("amount" , String(parseFloat(res.data.bank_amount == null ? 0 : res.data.bank_amount).toFixed(2)));
    formik.setFieldValue("walletBalance" , res.data.wallet_balance)
    console.log(res.data.wallet_balance)
  }
  )
   
.catch((err) => {console.log(err)})
  }
  useEffect(()=>{
    getOutletData()
  },[])
  console.log(moment(formik.values.date).format('DD-MM-YYYY'))
  console.log(formik.values)
  return (
    <React.Fragment>
           <Helmet>
              <title>
              Wallet Transfer
              </title>
            </Helmet>
   <Grid  className={classes.rootBox}>
   
    <Typography sx={{fontSize:22,fontWeight:600,color:"#000",}}>Wallet Transfer</Typography>
    {/* <Divider sx={{marginBlock:1,color:"red"}}/> */}
  <Grid sx={{width:"100%",maxWidth:"40%",margin:"0 auto",border:"1px solid #A06EE1",padding:3,borderRadius:1}}>
  <Grid sx={{display:"flex",justifyContent:"space-between"}}>
    <div style={{marginRight:20}}>
      <Typography className={classes.text} sx={{marginBlockEnd:.7}}>Date</Typography>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            name="date"
            
            format="DD-MM-YYYY"
            value={formik.values.date}
            onChange={(e) => formik.setFieldValue("date", moment(e._d))}
            // readOnly={isFlag === 1}
            disabled
            sx={{
              '& .MuiInputBase-input': { 
                color: 'black !important', 
                fontWeight: 'bold', 
              },
              '& .MuiOutlinedInput-notchedOutline': { borderColor: 'black !important' },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'black !important' },
              '& .MuiInputLabel-root': { color: 'black !important' },
            }}
            slotProps={{
              textField: {
                size: "small",
                error: formik.touched.date && Boolean(formik.errors.date),
                helperText: formik.touched.date && formik.errors.date,
              },
            }}
            disablePast
          />
        </LocalizationProvider>
        
        <Typography className={classes.text} sx={{marginBlockStart:1}}>Transfer From</Typography>
        
        <TextField
            id="bank"
            name="bank"
            size="small"
            fullWidth
            autoComplete="off"
            // placeholder="Enter amount"
            value={formik.values.bank}
            InputProps={{
              readOnly: true,
            }}
            sx={{
              backgroundColor:"#A06EE1",
              marginBlock:1,
              // color:"#fff !important",
              // '&.MuiTextField-root':{color:"#fff!important"},
                '& .MuiInputBase-input': { color: '#fff !important' },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent !important' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent !important' },
                '& .MuiInputLabel-root': { color: '#fff !important' },
              }}
            onChange={formik.handleChange}
            error={formik.touched.amount && Boolean(formik.errors.amount)}
            helperText={formik.touched.amount && formik.errors.amount}
        />
      </div>
      <div>
     <Typography className={classes.text}>Outlet</Typography>
     <Autocomplete
      id="outletId"
      name="outletId"
      size="small"
      options={outletData}
      getOptionLabel={(option) => option?.fullname }
      value={formik.values.outletId}
      onChange={handlChange}
      disableClearable
      isOptionEqualToValue={(option, value) =>option.fullname === value.fullname}
      renderInput={(params) => (
        <TextField
          {...params}
          className={classes.customtextfield}
          placeholder="Select Outlet"
          autoComplete="off"
          sx={{
            '& .MuiInputBase-input': { color: 'black !important' },
            '& .MuiOutlinedInput-notchedOutline': { borderColor: 'black !important' },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'black !important' },
            '& .MuiInputLabel-root': { color: 'black !important' },
          }}
          error={
            formik.touched.outletId && Boolean(formik.errors.outletId)
          }
          helperText={
            formik.touched.outletId && formik.errors.outletId
          }
        />
      )}
    />
   
      

     
        <Typography className={classes.text}>Amount</Typography>
        <TextField
            id="amount"
            name="amount"
            size="small"
            fullWidth
            autoComplete="off"
            // placeholder="Enter amount"
            value={formik.values.amount}
            InputProps={{
              readOnly: true,
            }}
            sx={{
              backgroundColor:"#A06EE1",
              marginBlock:1,
              // color:"#fff !important",
              // '&.MuiTextField-root':{color:"#fff!important"},
                '& .MuiInputBase-input': { color: '#fff !important' },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent !important' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent !important' },
                '& .MuiInputLabel-root': { color: '#fff !important' },
              }}
            onChange={formik.handleChange}
            error={formik.touched.amount && Boolean(formik.errors.amount)}
            helperText={formik.touched.amount && formik.errors.amount}
        />

     
        <Typography className={classes.text}>Wallet Balance</Typography>
        <TextField
            id="walletBalance"
            name="walletBalance"
            size="small"
            fullWidth
            InputProps={{
              readOnly: true,
            }}
            autoComplete="off"
            // placeholder="Enter wallet Balance"
            value={formik.values.walletBalance}
            sx={{
              backgroundColor:"#A06EE1",
              // color:"#fff !important",
              // '&.MuiTextField-root':{color:"#fff!important"},
                '& .MuiInputBase-input': { color: '#fff !important' },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent !important' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent !important' },
                '& .MuiInputLabel-root': { color: '#fff !important' },
              }}
            // InputProps={{readOnly: isFlag === 1 ? true : false}}
            onChange={formik.handleChange}
            error={formik.touched.walletBalance && Boolean(formik.errors.walletBalance)}
            helperText={formik.touched.walletBalance && formik.errors.walletBalance}
        />

      </div>
    </Grid>
     
    <Grid sx={{display:"flex",flexDirection:"column"}}>
    <div>
    <Typography className={classes.text}>Transfer Amount</Typography>
        <TextField
            id="transferAmount"
            name="transferAmount"
            size="small"
            fullWidth
            autoComplete="off"
            placeholder="Enter Transfer Amount"
            value={formik.values.transferAmount}
            className={classes.customtextfield}
            sx={{
                '& .MuiInputBase-input': { color: 'black !important' },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'black !important' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'black !important' },
                '& .MuiInputLabel-root': { color: 'black !important' },
              }}
            // InputProps={{readOnly: isFlag === 1 ? true : false}}
            onChange={formik.handleChange}
            error={formik.touched.transferAmount && Boolean(formik.errors.transferAmount)}
            helperText={formik.touched.transferAmount && formik.errors.transferAmount}
        />
    </div>
       

     
      <div>
      <Typography className={classes.text}>Description</Typography>
        <TextField
            id="Description"
            name="Description"
            size="small"
            fullWidth
            multiline
            rows={3}
            autoComplete="off"
            placeholder="Enter Description"
            value={formik.values.Description}
            sx={{
              // maxWidth:"50%",
                '& .MuiInputBase-input': { color: 'black !important' },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'black !important' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'black !important' },
                '& .MuiInputLabel-root': { color: 'black !important' },
              }}
            // InputProps={{readOnly: isFlag === 1 ? true : false}}
            onChange={formik.handleChange}
            error={formik.touched.Description && Boolean(formik.errors.Description)}
            helperText={formik.touched.Description && formik.errors.Description}
        />
      </div>
    

     
     
    
     <div>
      <Button sx={{marginBlockStart:2}} fullWidth variant="contained" onClick={formik.handleSubmit}>Submit</Button>
     </div>
    </Grid>
 
        
     
       
  </Grid>
    
    </Grid>
    </React.Fragment>
 
  );
};

export default WalletTransfer;
